import { render, staticRenderFns } from "./OccurrenceDetail.vue?vue&type=template&id=9d42d25a&scoped=true&"
import script from "./OccurrenceDetail.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetail.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDetail.vue?vue&type=style&index=0&id=9d42d25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d42d25a",
  null
  
)

export default component.exports